<template>
  <div class="filters-section">
    <b-form-group label="Pesquisar" class="search-filter">
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>
            <i class="fas fa-search" aria-hidden="true"></i>
          </b-input-group-text>
        </b-input-group-prepend>
        <b-form-input
          v-model="localFilter.text"
          type="search"
          placeholder="Pesquisar por empresa, protocolo, nome, CPF ou relato"
          @input="debounceFilter"
          @keyup.enter="applyNow"
          @search="applyNow"
        ></b-form-input>
      </b-input-group>
    </b-form-group>

    <b-form-group label="Status" class="status-filter">
      <b-form-select
        v-model="localFilter.status"
        class="custom-select"
        @change="applyNow"
      >
        <b-form-select-option :value="null">Todos</b-form-select-option>
        <b-form-select-option :value="ombudsmanStatus.NEW"
          >Nova</b-form-select-option
        >
        <b-form-select-option :value="ombudsmanStatus.PROCESSING"
          >Em processamento</b-form-select-option
        >
        <b-form-select-option :value="ombudsmanStatus.CONCLUDED"
          >Concluída</b-form-select-option
        >
      </b-form-select>
    </b-form-group>

    <b-button
      variant="outline-secondary"
      class="clear-filters-btn"
      @click="clearFilters"
    >
      <i class="fas fa-eraser mr-1"></i> Limpar
    </b-button>
  </div>
</template>

<script>
export default {
  name: "OmbudsmanFiltersBar",
  props: {
    filter: {
      type: Object,
      required: true,
    },
    ombudsmanStatus: {
      type: Object,
      required: true,
    },
    profile: {
      type: Object,
      required: true,
    },
    hasAdvancedSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localFilter: { ...this.filter },
      filterTimeout: null,
    };
  },
  watch: {
    filter: {
      deep: true,
      handler(newVal) {
        this.localFilter = { ...newVal };
      },
    },
  },
  beforeDestroy() {
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
  },
  methods: {
    emitUpdate() {
      this.$emit("update:filter", { ...this.localFilter });
    },
    applyNow() {
      this.emitUpdate();
      this.$emit("apply");
    },
    debounceFilter() {
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.applyNow();
      }, 300);
    },
    clearFilters() {
      this.localFilter = {
        text: "",
        status: null,
      };
      this.applyNow();
    },
  },
};
</script>

<style scoped>
.filters-section {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  align-items: flex-end;
}

.search-filter {
  flex: 1;
}

.status-filter {
  flex-basis: 250px;
}

.filters-section .form-group {
  margin-bottom: 0;
}

.filters-section .form-control,
.filters-section .custom-select {
  border-radius: 6px;
  border: 1px solid #e9ecef;
  background-color: #fff;
  color: #495057;
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.filters-section .form-control:focus,
.filters-section .custom-select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
  outline: 0;
}

.filters-section .input-group-text {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-right: 0;
  border-radius: 6px 0 0 6px;
}

.filters-section .form-group label {
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  color: #495057;
  margin-bottom: 0.5rem;
}

.clear-filters-btn {
  height: calc(1.5em + 1rem + 2px);
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  white-space: nowrap;
}
</style>
